import { Loading } from '@components/common';
import { get } from 'lodash';
import { usageMetricList } from '@src/components/usage-dashboard/atoms';
import { useFetchAppUsageMetric } from '@src/components/usage-dashboard/hooks/dataFetcherhooks';
import { useMakeExportData } from '@src/components/usage-dashboard/hooks/useMetricSeries';
import UsageMetricCard from '@src/components/usage-dashboard/MetricsPanel/UsageMetricCard/UsageMetricCard';
import { ServerError } from '@components/common/Retry/Elements';
import { Col, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import React from 'react';
import '../metricpanel.css';

const AppMetricsPanel = () => {
  const {
    data: seriesData,
    isFetching,
    error,
  }: any = useFetchAppUsageMetric({
    enabled: true,
    product: 'APP',
  });

  useMakeExportData({
    seriesData,
    sectionKey: 'ud-app-metric-timeseries',
    title: 'App Usage Metrics',
  });
  const metricList = Object.keys(usageMetricList).filter(
    (key) => usageMetricList[key].product === 'APP',
  );

  if (isFetching) {
    return <Loading></Loading>;
  }

  const renderContent = () => {
    if (error) {
      const errorMsg = get(
        error,
        'response.data.message',
        'Something went wrong. Please try again',
      );
      return (
        <div style={{ height: '100px' }}>
          <ServerError message={errorMsg} />
        </div>
      );
    }

    return (
      <Row gutter={{ xs: 4, md: 8, lg: 12 }} className="rowStyle">
        {metricList.map((metric) => (
          <Col key={metric} xs={24} md={12} lg={12} className="colStyle">
            <UsageMetricCard metric={metric}></UsageMetricCard>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <div>
      <Title level={5} className="titleStyle">
        App Usage
      </Title>
      {renderContent()}
    </div>
  );
};

export default AppMetricsPanel;
